/**
 * "Once per app launch" for things mounted at the app root.
 *
 * A root component's mount effect is NOT once per launch: several in-app moves
 * reload the whole page (safeNavigate leaving the Shop, «Vai al profilo», the
 * back-to-Home rule after a long background), and every reload mounts the app
 * again. sessionStorage is the right scope: it survives those reloads inside
 * the WebView and is gone when the app is closed and opened again.
 */
const keyFor = (name) => `oncePerLaunch:${name}`;

export const hasHappenedThisLaunch = (name) => {
  try {
    return sessionStorage.getItem(keyFor(name)) === "1";
  } catch {
    return false;
  }
};

export const markHappenedThisLaunch = (name) => {
  try {
    sessionStorage.setItem(keyFor(name), "1");
  } catch {
    // Storage unavailable: it may show again after an in-app reload.
  }
};
